import * as Yup from "yup";

export const profileValidationSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .min(2, "Имя должно содержать минимум 2 символа")
    .required("Укажите имя")
    .max(50, "Имя должно содержать максимум 50 символов"),
  birth_date: Yup.date()
    .typeError("Укажите корректную дату рождения")
    .required("Укажите дату рождения")
    .max(new Date(), "Дата рождения не может быть в будущем"),
  job_title: Yup.string()
    .trim()
    .min(2, "Минимум 2 символа")
    .required("Укажите должность")
    .max(150, "Максимум 150 символов"),
  city: Yup.string()
    .trim()
    .min(1, "Минимум 1 символ")
    .required("Укажите город")
    .max(100, "Максимум 100 символов"),
  description: Yup.string()
    .required("Расскажите о себе")
    .max(300, "Максимум 300 символов"),
});
